<div class="header-tools">
  <button (click)="navigateToOtherComponent([''])">Go to Map Page</button>
  <p>tools-page</p>
  <button (click)="refreshJmkw()">Refresh JMKW</button>
</div>

<div style="margin: 2em;">
  <h3>Edit Plugin Configuration Map (JSON)</h3>
  <textarea
    [(ngModel)]="pluginConfigJson"
    rows="40"
    cols="60"
    style="font-family:monospace;"
  ></textarea>
  @if (error) {
    <div style="color: red;">{{ error }}</div>
  }
  <button (click)="saveConfig()" style="margin:1em;">Save</button>
  <button (click)="resetToDefault()" style="margin:1em;">Reset to Default</button>
</div>
